class ShareCatMessenger{
	constructor(){
    let ua = navigator.userAgent.toLowerCase();
  	this.isIos = ( /iphone|ipad/gi ).test( ua );
  	this.isAndroid = ( /android/gi ).test( ua );
  	this.isChrome = ( ua.search( 'chrome' ) > -1 );
  	this.iosAppLink = 'http://itunes.apple.com/kr/app/ncmesinjeo/id512119346';
  	this.androidAppLink = 'market://details?id=com.ncsoft.android.apps.ncm';
  }

	ncAppDownload( appName ){
		let url = This = this;

		if( This.isIos && appName == 'ncmessager' ){//IOS
			url = This.iosAppLink;
		}else if ( This.isAndroid && appName == 'ncmessager' ){ // android
			url = "https://play.google.com/store/apps/details?id=com.ncsoft.android.apps.ncm";
		}

		if( url ) window.open( url );
	}

	installApp() {
		let baseTime = +new Date, This = this;
		setTimeout(function() {
			if( 2000 > +new Date - baseTime ){
				if( This.isIos ){
					document.location.href = This.iosAppLink;
				}else if( This.isAndroid ){
					document.location.href = This.androidAppLink;
				}
			}
		}, 500);
	}

	setTxtFormat( obj ){
		let This = this,
			txt = obj.text || 'plaync',
			mUrl = obj.url || 'http://plaync.com',
			mImg = obj.img || '',
			tmpl, tmpContent;

		txt = encodeURIComponent( txt );
		mUrl = encodeURIComponent( mUrl );
		mUrl = mUrl.replace( /\s/g, '+' );

		let scheme = 'ncm://';

		if( This.isAndroid && This.isChrome ) scheme = 'intent://';

		//tmpl =  'ncm://message?text=' + encodeURIComponent( txt ) + encodeURIComponent( '\n' ) + encodeURIComponent( mUrl ) +'&content=';
		tmpl =  'message?text=' + ( txt + '%0A' + mUrl ) +'&content=';

		tmpl = scheme + tmpl;

		tmpContent = '<div class="p" data-type="T" data-icontype="0" data-url="'+ mUrl +'">'+
						'<span class="text">'+ txt +'</span>'+
						'</div>'+
						'<div class="p" data-type="T" data-icontype="0" data-url="'+ mUrl +'"><span class="text"><font size="2" color="#42c2c8">more ▶</font></span></div>';

		tmpContent = encodeURIComponent( tmpContent );

		tmpl = tmpl + tmpContent;
		return tmpl;
	};

	sendNCMessage( obj ) {
		let This = this, tmpl = This.setTxtFormat( obj );

		if( This.isAndroid && This.isChrome ){
			window.location = tmpl + "#Intent;scheme=ncm;package=com.ncsoft.android.apps.ncm;end;";
		}else{
			let linkDiv = document.getElementById( 'appLinkDiv' );

			if( !linkDiv ){
				linkDiv = document.createElement( 'div' );
				linkDiv.id = 'appLinkDiv';
				linkDiv.style.display = 'none';
				document.body.appendChild( linkDiv );
			}

			let frame = document.createElement( 'iframe' );
			frame.style.display = 'none';

			linkDiv.appendChild( frame );

			frame.src = tmpl;

			this.installApp();
		}
	}

	execute( msg, url, img ) {
		this.sendNCMessage({text: msg, url: url, img: img});
	}
}

export default ShareCatMessenger;
